import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfTooltipProps {
    /**
     * 子元素
     */
    children: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * tooltip 提示语
 */
const EfTooltip: React.FC<EfTooltipProps> = ({ children, className }) => {
    const prefixCls = `ef-tooltip`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <dialog className={classes}>
            <div className={`${prefixCls}-in`}>{children}</div>
            <div className={`${prefixCls}-arr`}></div>
        </dialog>
    );
};

export default EfTooltip;
